// extracted by mini-css-extract-plugin
export default {"container":"APIDocumentation_container__yjt2U"};